import { ButtonProps } from "@chakra-ui/react"
import { Button as ChakraButton } from "@chakra-ui/react"
import { ActionButtonContent } from "../types/button-content"
import { Tooltip } from "@hydrologiq/shared/chakra/Tooltip"

export type ActionButtonProps = ButtonProps & { context?: ActionButtonContent; description?: string }

export const ActionButton = (props: ActionButtonProps) => {
  const description = props.description || props.context?.description
  // Allow children to override context label
  const buttonLabel = props.children || props.context?.label
  return (
    // No description, no tooltip: an empty one shows a blank bubble on hover
    <Tooltip disabled={props.disabled || !description} content={description}>
      <ChakraButton
        variant={
          props.context?.variant === "secondary"
            ? "hydrologiq_secondary"
            : props.context?.variant === "primary"
            ? "hydrologiq_primary"
            : props.context?.variant || "hydrologiq_primary"
        }
        size={props.size || "sm"}
        aria-label={props["aria-label"] || description}
        {...props}
      >
        {buttonLabel}
      </ChakraButton>
    </Tooltip>
  )
}
